/**
 * Body Insight Router
 *
 * Routing for 5 body insight pages with sequential navigation.
 * Feature: 017-body-insight-summary
 */

import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { BodyInsightGuard } from '../../components/body-insight/BodyInsightGuard';
import Page1BodyRightNow from './Page1BodyRightNow';
import Page2WhatYoureFeeling from './Page2WhatYoureFeeling';
import Page3WhatYouWant from './Page3WhatYouWant';
import Page4YourFocus from './Page4YourFocus';
import Page5TwelveWeekTimeline from './Page5TwelveWeekTimeline';

export const BodyInsightRouter: React.FC = () => {
  return (
    <BodyInsightGuard>
      <Routes>
        {/* Default redirect to page 1 */}
        <Route path="/" element={<Navigate to="/body-insight/1" replace />} />

        {/* Body Insight Pages */}
        <Route path="/1" element={<Page1BodyRightNow />} />
        <Route path="/2" element={<Page2WhatYoureFeeling />} />
        <Route path="/3" element={<Page3WhatYouWant />} />
        <Route path="/4" element={<Page4YourFocus />} />
        <Route path="/5" element={<Page5TwelveWeekTimeline />} />

        {/* Catch-all - redirect to page 1 */}
        <Route path="*" element={<Navigate to="/body-insight/1" replace />} />
      </Routes>
    </BodyInsightGuard>
  );
};
